import { render, staticRenderFns } from "./cooperationProviderList.vue?vue&type=template&id=0d042059&scoped=true&"
import script from "./cooperationProviderList.vue?vue&type=script&lang=babel&"
export * from "./cooperationProviderList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d042059",
  null
  
)

export default component.exports